import QnaDetailPageComponent from "../../Qna/components/detail";
import React, {useEffect, useState} from "react";
import API, {ROUTES} from "../../../commons/api/api";
import {useParams} from "react-router-dom";

const QnaDetailPageContainer  = () => {

    const [dataDetail, setDataDetail] = useState([])
    const [loading, setLoading] = useState(true)
    const params = useParams();
    var id = params?.id ? params?.id : ''

    const fetchData = async (param = '') =>{
        try {
            const {data: response} = await API.get(ROUTES.API_QNA+(param ? '?id='+param : ''));
            setDataDetail(response?.data);
            setLoading(false)
        } catch (error) {
            console.error(error.message);
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchData(id);
    }, []);

    const loadMoreData = () => {

    }

    return <QnaDetailPageComponent loading={loading} dataDetail={dataDetail}

    />;
};

export default QnaDetailPageContainer ;